<template>
  <el-dialog
    title="自定义分组"
    :visible.sync="visible"
    width="680px"
    append-to-body
    :before-close="done => (confirmLoading ? '' : done())"
  >
    <el-form @submit.native.prevent label-width="90px" label-position="left" class="group-editor-modal">
      <el-form-item label="名称">
        <el-input v-model.trim="formInfo.name" placeholder="请输入自定义分组名称" maxlength="30" />
      </el-form-item>
      <el-form-item>
        <div class="group-form-item-label" slot="label">
          <span>涉及主体</span>
          <el-popover placement="bottom-start" title="" width="612" trigger="hover">
            <labelGroupPreview type="ner" />
            <i slot="reference" class="el-icon-question"></i>
          </el-popover>
        </div>
        <el-select
          v-model="formInfo.nerIds"
          placeholder="请选择研究的1个或多个主体标签，作为研究对象"
          multiple
          clearable
          :style="{ width: '100%' }"
        >
          <el-option
            v-for="fieldDetail in nerLabels"
            :key="fieldDetail.field_name"
            :value="fieldDetail.field_name"
            :label="fieldDetail.title"
          />
        </el-select>
      </el-form-item>
      <el-form-item>
        <div class="group-form-item-label" slot="label">
          <span>涉及事件</span>
          <el-popover placement="bottom-start" title="" width="612" trigger="hover">
            <labelGroupPreview type="label" />
            <i slot="reference" class="el-icon-question"></i>
          </el-popover>
        </div>
        <el-select
          :value="formInfo.labelIds[0]"
          placeholder="请选择分类标签，可以逐个子分类进行研究"
          :style="{ width: '100%' }"
          clearable
          @change="val => (formInfo.labelIds = !val ? [] : [val])"
        >
          <el-option
            v-for="fieldDetail in normalLabels"
            :key="fieldDetail.field_name"
            :value="fieldDetail.field_name"
            :label="fieldDetail.title"
          />
        </el-select>
      </el-form-item>
    </el-form>
    <span slot="footer">
      <el-button @click="visible = false">取 消</el-button>
      <el-button type="primary" :loading="confirmLoading" @click="confirmHandle()">确 定</el-button>
    </span>
  </el-dialog>
</template>

<script setup>
import labelGroupPreview from './labelGroupPreview.vue';
import { errFunc } from '@/lib/utils';
import { Message } from 'element-ui';
import { computed, onMounted, reactive, ref } from 'vue';
import { services } from '@/service';

const emit = defineEmits(['update:show', 'change']);
const props = defineProps(['show', 'courseId']);

const visible = computed({
  get() {
    return props.show;
  },
  set(val) {
    emit('update:show', val);
  }
});

onMounted(() => fetchCourseFields());
const fields = ref([]);
const nerLabels = computed(() =>
  fields.value.filter(o => o.type === 'text' && ['entity_ner', 'entity_natural_person'].includes(o.deputy_type))
);
const normalLabels = computed(() => fields.value.filter(o => o.type === 'text' && ['dict'].includes(o.deputy_type)));
const fetchCourseFields = async () => {
  try {
    fields.value = await services.courseware.getFields(props.courseId);
  } catch (err) {
    errFunc(err);
  }
};

const formInfo = reactive({
  name: '',
  nerIds: [],
  labelIds: []
});

const confirmLoading = ref(false);
const confirmHandle = async () => {
  if (!formInfo.name) {
    Message.warning('请输入自定义分组名称');
    return;
  }
  if (formInfo.nerIds.length < 1) {
    Message.warning('请选择涉及主体的标签');
    return;
  }
  try {
    confirmLoading.value = true;

    await services.courseware.postCourseUnitGroup({ ...formInfo, coursewareId: props.courseId });

    Message.success('分组保存成功');
    emit('change');
    confirmLoading.value = false;
    visible.value = false;
  } catch (err) {
    confirmLoading.value = false;
    errFunc(err);
  }
};
</script>

<style lang="scss" scoped>
.group-editor-modal {
  .group-form-item-label {
    .el-icon-question {
      color: #9599a5;
      margin-left: 4px;
    }
  }
}
</style>
